import React from 'react';

const Shipping = () => {
    return (
        <div>
            <h2>Shipping</h2>
            <p>Delivery On The Way.</p>
            <p><small>Coming Soon</small></p>
        </div>
    );
};

export default Shipping;